export const LanguagesInFrancisco = [
  {
    heading: "Chinese",
    detail:
      "San Francisco has an 18% population of native Chinese speakers. That means there might be a demand for translations in the Chinese language to the English language, and vice versa, or any other language pair for that matter. Chinese is an important business language globally as well, if you're thinking of expanding internationally.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Spanish",
    detail:
      "10.1% of San Francisco residents speak Spanish--and wouldn't translations into or from Spanish make things easier for this demographic? Spanish is spoken by a majority of Americans, so integrating translation services to your business plans could ease communications through this language. Reach out now to get started.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Tagalog",
    detail:
      "A significant portion of San Francisco residents speak Tagalog: 10,000 Tagalog-speaking residents with limited English proficiency. Tagalog is the 3rd required language for San Francisco city, according to San Francisco newspapers. If you're looking to bridge the language gap for this demographic, translation services would be a perfect fit.",
    link: "/tagalog-translation.php",
  },
  {
    heading: "Vietnamese",
    detail:
      "Vietnamese is spoken by 10,939 San Francisco residents. Vietnamese is also spoken by 75 million people worldwide. If you're a San Francisco business looking to go beyond the Bay Area, you may need translation services in Vietnamese, whether it be for website and app localization or technical translation.",
    link: "/vietnamese-translation.php",
  },
  {
    heading: "French",
    detail:
      "A major global language as well as a language commonly spoken in San Francisco, French translation services are the perfect way to connect with 6,777 San Francisco residents who speak it. Stepping foot outside of San Francisco, translation services would also equip you with transforming your documents from French to English or French to any other language.",
    link: "/french-translation.php",
  },
  {
    heading: "Japanese",
    detail:
      "Japanese is another global business language for which translation might help out a segment of San Francisco residents: 6,624 of them to be exact. Tomedes can provide you with native Japanese translators and the right translation tools to make translations much easier and much smarter.",
    link: "/japanese-translation.php",
  },
];
